import Carousel from './components/Carousel';
import { Link } from 'react-router-dom';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-100">
      <Carousel />
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          
          {/* Left Content */}
          <div>
            <p className="text-sm font-semibold text-light-grey-500 uppercase tracking-wide">Welcome</p>
            <h1 className="mt-2 text-4xl font-bold text-gray-900">Our Lady Queen of Martyrs & St Swithin's</h1>
            <p className="mt-4 text-lg text-gray-700">
              Welcome to Our Lady Queen of Martyrs & St Swithin's.
              The Church is open for people to attend mass. Please see the newsletter for current information with mass intentions and funerals.
            </p>
          </div>

          {/* Right Image */}
          <div className="flex justify-center lg:justify-end">
            <img
              src="/pictures/Garden_2.jpg"
              alt="Profile or welcome illustration"
              className="w-120 h-120 object-cover rounded-xl shadow-lg"
            />
          </div>
        </div>
      </section>

      <section className="py-10">
        <div className="max-w-5xl mx-auto px-4 text-center">

          <p className="mb-10 text-gray-600 text-base">
              More to explore
          </p>
          
          {/* Button Grid */}
          <div className="flex flex-col items-center space-y-6 sm:flex-row sm:justify-center sm:space-y-0 sm:space-x-12">
            {/* Image Button 1 */}
            <Link
              to="https://www.churchservices.tv/croxteth"
              className="relative w-60 h-60 rounded-lg overflow-hidden shadow-lg group"
            >
              <img
                src="/pictures/Church_Overview.jpg"
                alt="Live Mass"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <span className="text-white text-lg font-semibold">Live Mass</span>
              </div>
              <div className="absolute bottom-0 left-0 w-full bg-white/80 py-2 text-center">
                    <h3 className="text-sm font-medium text-gray-800">Live Mass</h3>
                  </div>
            </Link>

            <Link
              to="https://archdioceseofliverpool.churchsuite.com/donate/fund/evylqnud"
              className="relative w-60 h-60 rounded-lg overflow-hidden shadow-lg group"
            >
              <img
                src="/archdiocese-logo.png"
                alt="Live Mass"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <span className="text-white text-lg font-semibold">Donations</span>
              </div>
              <div className="absolute bottom-0 left-0 w-full bg-white/80 py-2 text-center">
                    <h3 className="text-sm font-medium text-gray-800">Donations</h3>
                  </div>
            </Link>

            {/* Image Button 2 */}
            <Link
              to="/sacraments"
              className="relative w-60 h-60 rounded-lg overflow-hidden shadow-lg group"
            >
              <img
                src="/pictures/Offering.jpg"
                alt="Sacraments"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <span className="text-white text-lg font-semibold">Sacraments</span>
              </div>
              <div className="absolute bottom-0 left-0 w-full bg-white/80 py-2 text-center">
                <h3 className="text-sm font-medium text-gray-800">Sacraments</h3>
              </div>
            </Link>

            {/* Image Button 3 */}
            <Link
              to="/gallery"
              className="relative w-60 h-60 rounded-lg overflow-hidden shadow-lg group"
            >
              <img
                src="/pictures/Alter.jpg"
                alt="Gallery"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <span className="text-white text-lg font-semibold">Gallery</span>
              </div>
              <div className="absolute bottom-0 left-0 w-full bg-white/80 py-2 text-center">
                <h3 className="text-sm font-medium text-gray-800">Gallery</h3>
              </div>
            </Link>
          </div>
        </div>
      </section>
    </div>
  )
}